import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { mq, Clickable, mediumBreakpoint } from '@phishtool/ui';
export const StyledNavigationWrapper = styled.nav.withConfig({ displayName: "StyledNavigationWrapper", componentId: "-o7jrc7" }) `
  top: 100%;
  left: 0;
  right: 0;

  ${(props) => mq({
    backgroundColor: [props.theme.colors.white, null, 'transparent'],
    alignItems: ['flex-start', null, 'center'],
    position: ['absolute', null, 'static'],
    flexDirection: ['column', null, 'row'],
    overflow: ['auto', null, 'unset'],
    transform: [`translate(${props.isOpen ? '0' : '100%'})`, null, 'unset'],
    transition: [props.hasTransition ? 'transform 0.25s' : 'unset', null, 'unset'],
    width: ['100vw', null, 'auto'],
    height: ['100vh', null, 'auto'],
    display: ['none', null, 'flex'],
    // display: [props.isOpen ? 'block' : 'none', null, 'flex'],
    // visibility: [props.isOpen ? 'visible' : 'hidden', null, 'visible'],
})}
`;
export const StyledSubNavMenu = styled.div.withConfig({ displayName: "StyledSubNavMenu", componentId: "-z5t6u7" }) `
  background-color: ${(props) => props.theme.colors.white};
  left: 0;

  ${(props) => mq({
    display: ['block', null, 'none'],
    width: ['auto', null, '100vw'],
    position: ['static', null, 'absolute'],
    padding: ['0', null, `${props.theme.spacers.xxl} 0`],
    boxShadow: ['none', null, props.theme.shadows.primary],
})}

  .sub-item-grid {
    transition: max-height 0.5s;

    ${(props) => mq({
    display: ['block', null, 'grid'],
    overflow: ['hidden', null, 'unset'],
    maxHeight: [props.isOpen ? '100px' : '0', null, 'unset'],
})}
  }
`;
export const StyledNavigationItemWrapper = styled.div.withConfig({ displayName: "StyledNavigationItemWrapper", componentId: "-10gwluk" }) `
  padding: 0 0 3px;
  border-top: 3px solid ${(props) => (props.isActive ? props.theme.colors.white : 'transparent')};

  ${(props) => mq({
    width: ['100%', null, 'auto'],
    borderBottom: [`1px solid ${props.theme.colors.silverPearl}`, null, 'none'],
    padding: [`${props.theme.spacers.xl} 0`, null, 0],
    display: [props.desktopOnly ? 'none' : 'block', null, props.mobileOnly ? 'none' : 'block'],
})}

  @media (max-width: ${mediumBreakpoint - 1}px) {
    .shape {
      border-top: ${(props) => (props.isOpen ? 'none' : `10px solid ${props.theme.colors.oxfordBlue}`)};
      border-right: 8px solid transparent;
      border-bottom: ${(props) => (props.isOpen ? `10px solid ${props.theme.colors.oxfordBlue}` : 'none')};
      border-left: 8px solid transparent;
    }
  }

  @media (min-width: ${mediumBreakpoint}px) {
    &:hover {
      border-color: ${(props) => (props.isActive ? props.theme.colors.white : props.theme.colors.shadowBlue)};

      ${StyledSubNavMenu} {
        display: block;
      }

      .shape {
        border-top: none;
        border-right: 6px solid transparent;
        border-bottom: 8px solid ${(props) => props.theme.colors.white};
        border-left: 6px solid transparent;
      }
    }
  }
`;
const sharedNavigationItemStyles = css `
  display: flex;
  align-items: center;
  gap: ${(props) => props.theme.spacers.small};
  text-decoration: none;

  ${(props) => mq({
    color: [props.theme.colors.oxfordBlue, null, props.theme.colors.white],
    padding: [`0 ${props.theme.spacers.xxxl} 0 ${props.theme.spacers.xl}`, null, `0 ${props.theme.spacers.medium}`],
    fontSize: ['18px', null, '14px'],
    fontWeight: ['700', null, '500'],
    height: ['auto', null, '52px'],
    justifyContent: ['space-between', null, 'flex-start'],
})}

  .icon {
    ${mq({
    display: ['none', null, 'flex'],
})}
  }
`;
export const StyledNavigationLink = styled(Link).withConfig({ displayName: "StyledNavigationLink", componentId: "-gbnfxw" }) `
  ${sharedNavigationItemStyles}
`;
export const StyledNavigationAnchor = styled.a.withConfig({ displayName: "StyledNavigationAnchor", componentId: "-1ftgpiq" }) `
  ${sharedNavigationItemStyles}
`;
export const StyledSubNavMenuHeadingWrapper = styled.div.withConfig({ displayName: "StyledSubNavMenuHeadingWrapper", componentId: "-7d7ph4" }) `
  ${mq({
    display: ['none', null, 'block'],
})}
`;
export const StyledSubNavMenuHeading = styled.h2.withConfig({ displayName: "StyledSubNavMenuHeading", componentId: "-9cm6g3" }) `
  display: flex;
  gap: ${(props) => props.theme.spacers.medium};
  align-items: center;
  font-size: 23px;
  font-weight: 700;
  margin: 0 0 ${(props) => props.theme.spacers.xxl};
  color: ${(props) => props.theme.body.textColor};
`;
export const StyledSubNavMenuItem = styled(Link).withConfig({ displayName: "StyledSubNavMenuItem", componentId: "-150u1e2" }) `
  display: block;
  text-decoration: none;
  color: ${(props) => props.theme.body.textColor};

  &:hover {
    color: ${(props) => props.theme.colors.celticBlue};
  }
`;
export const StyledSubNavMenuItemHeading = styled.h3.withConfig({ displayName: "StyledSubNavMenuItemHeading", componentId: "-gxgmay" }) `
  ${(props) => mq({
    margin: [`${props.theme.spacers.medium} 0 0 ${props.theme.spacers.xl}`, null, `0 0 ${props.theme.spacers.small}`],
    fontWeight: [500, null, 700],
    fontSize: ['14px', null, '18px'],
})}
`;
export const StyledSubNavMenuItemDescription = styled.p.withConfig({ displayName: "StyledSubNavMenuItemDescription", componentId: "-5qmibf" }) `
  font-size: 14px;
  margin: 0;

  ${mq({
    display: ['none', null, 'block'],
})}
`;
export const StyledMobileToggle = styled(Clickable).withConfig({ displayName: "StyledMobileToggle", componentId: "-fuzy6z" }) `
  width: 20px;
  height: 15px;
  flex-direction: column;
  gap: 3px;
  position: relative;

  ${mq({
    display: ['flex', null, 'none'],
})}
`;
export const StyledHamburgerLine = styled.div.withConfig({ displayName: "StyledHamburgerLine", componentId: "-1mwcokn" }) `
  width: 100%;
  height: 3px;
  background-color: ${(props) => props.theme.colors.white};
  border-radius: 2.5px;
`;
export const StyledCrossLine = styled.div.withConfig({ displayName: "StyledCrossLine", componentId: "-18yzu2t" }) `
  width: 18px;
  height: 3px;
  background-color: ${(props) => props.theme.colors.white};
  border-radius: 2.5px;
  position: absolute;
  top: 5px;
`;
export const StyledSecondaryNavLinks = styled.div.withConfig({ displayName: "StyledSecondaryNavLinks", componentId: "-1rs3n5w" }) `
  padding: ${(props) => props.theme.spacers.xl};
  gap: ${(props) => props.theme.spacers.xl};

  ${mq({
    display: ['flex', null, 'none'],
})}
`;
export const StyledSecondaryNavLink = styled.a.withConfig({ displayName: "StyledSecondaryNavLink", componentId: "-1h93fwz" }) `
  display: flex;
  align-items: center;
  color: ${(props) => props.theme.colors.oxfordBlue};
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  gap: ${(props) => props.theme.spacers.small};
`;
